import offersIcon1 from "../../assets/images/common/offers/MobiKwik-Logo.svg";

export interface OfferDetails {
  title: string;
  points: string[];
}

export interface OfferType {
  id: number;
  title: string;
  icon: string;
  shortDescription: string;
  validTill: string;
  code?: string;
  mainTitle: string;
  offers: OfferDetails[];
}

export const offersList: OfferType[] = [
  {
    id: 1,
    icon: offersIcon1,
    title:
      "Scratch and Get Flat Rs.100 on the first ever transaction via MobiKwik",
    shortDescription:
      "Exclusive Offers for MChemist. Flat cashback on UPI & Wallet transactions.",
    validTill: "30 September 2025",
    code: "",
    mainTitle: "Exclusive Offers for MChemist",
    offers: [
      {
        title: "Offer 1: New User UPI Offer",
        points: [
          "Flat Rs. 100 Cashback for payments via Mobikwik UPI.",
          "Offer is valid for all users on a minimum transaction value of Rs.999.",
          "First time ever with MobiKwik UPI",
          "Offer valid once per user per month.",
          "100% cashback funding by MobiKwik — no financial commitment from your end",
          "Offer is applicable once per month till 30th September '25.",
        ],
      },
      {
        title: "Offer 2: Existing UPI Offer",
        points: [
          "Get upto 15% cashback for your payments via Mobikwik UPI Only.",
          "Offer is valid for all users on a minimum transaction value of Rs.399.",
          "Offer valid once per user per month.",
          "The user must transact using the Mobikwik UPI (@ikwik handle) only to avail the offer.",
          "Eligible users will get the cashback in their MobiKwik within 24hrs of their transaction.",
          "Cashback will only be processed for KYC customers who have the Mobikwik App MobiKwik.",
          "Offer is applicable once per month till 30th September '25.",
        ],
      },
      {
        title: "Offer 3: Wallet Offer",
        points: [
          "Get Up to Rs. 100 Cashback for payments via Mobikwik Wallet.",
          "Offer is valid for all users on a minimum transaction value of Rs.399.",
          "Offer valid once per user per month.",
          "100% cashback funding by MobiKwik — no financial commitment from your end",
          "Offer is applicable once per month till 30th September '25.",
        ],
      },
    ],
  },
];
